import React from "react";
import PropTypes from "prop-types";
import Chip from "../Chip/Chip";

import "./CardMenu.scss";

const CardMenu = ({
  categories,
  selectedCategory,
  categorySelectedHandler,
}) => (
  <div className="cardmenu" data-testid="cardmenu">
    {categories.map((chip) => (
      <Chip
        key={chip.name}
        label={chip.name}
        isSelected={selectedCategory === chip.name}
        selectNew={categorySelectedHandler}
      />
    ))}
  </div>
);

CardMenu.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.exact({
      name: PropTypes.string.isRequired,
      body: PropTypes.object.isRequired,
    })
  ),
  selectedCategory: PropTypes.string.isRequired,
  categorySelectedHandler: PropTypes.func.isRequired,
};

export default CardMenu;
